import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import {
  LightMode as LightModeIcon,
  DarkMode as DarkModeIcon,
  SettingsBrightness as AutoModeIcon,
} from '@mui/icons-material';
import { useThemeMode } from '../contexts/ThemeContext';

const ThemeToggleButton: React.FC = () => {
  const { mode, toggleMode } = useThemeMode();

  const getIcon = () => {
    switch (mode) {
      case 'light':
        return <LightModeIcon />;
      case 'dark':
        return <DarkModeIcon />;
      case 'system':
        return <AutoModeIcon />;
      default:
        return <AutoModeIcon />;
    }
  };

  const getTooltip = () => {
    switch (mode) {
      case 'light':
        return 'Modo claro (click para modo oscuro)';
      case 'dark':
        return 'Modo oscuro (click para automático)';
      case 'system':
        return 'Modo automático (click para modo claro)';
      default:
        return 'Cambiar tema';
    }
  };

  return (
    <Tooltip title={getTooltip()}>
      <IconButton
        color="inherit"
        onClick={toggleMode}
        sx={{
          transition: 'transform 0.2s ease-in-out',
          '&:hover': {
            transform: 'rotate(15deg)',
          },
        }}
      >
        {getIcon()}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggleButton; 